import Axios from 'helpers/http'
import {
  generateJetpacB2BHostname,
  generateJetpacCatalogHostname,
  generateJetpacOpsHostname,
  generateJetpacPayHostname,
  generateJetpacRewardHostname,
  generateJetpacSimHostname,
  generateNewSimHostname,
  generateOrbitHostname,
  generateOrbitPayHostname
} from 'helpers/http/generateHostname'

import {
  B2B_API_PREFIX,
  FABER_PREFIX,
  PAYMENT_API_PREFIX,
  SIM_OPS_PREFIX,
  SIM_OPS_V2_PREFIX,
  SIM_REVAMP_OPS_PREFIX,
  VERSION_ONE_API_PREFIX
} from '../constants'

// production
// jetpac-sim       https://orbit-sim.circles.life
// jetpac-pay       https://api.jetpacglobal.com
// jetpac-reward    https://orbit-api.circles.life
// jetpac-catalog   https://orbit-api.circles.life
// orbit-pay        https://orbit-api.circles.life
// orbit            https://orbit-api.circles.life

// staging
// jetpac-sim       https://ssg-orbit-sim.circleslife.co
// jetpac-pay       https://ssg-orbit-api.circleslife.co
// jetpac-reward    https://ssg-orbit-api.circleslife.co
// jetpac-catalog   https://ssg-orbit-api.circleslife.co
// orbit-pay        https://ssg-orbit-api.circleslife.co
// orbit            https://ssg-orbit-api.circleslife.co

export const JetpacSimApi = new Axios(
  generateJetpacSimHostname(),
  VERSION_ONE_API_PREFIX
)
export const NewJetpacSimApi = new Axios(generateNewSimHostname(), FABER_PREFIX)
export const JetpacPayApi = new Axios(
  generateJetpacPayHostname(),
  PAYMENT_API_PREFIX
)
export const JetpacRewardApi = new Axios(
  generateJetpacRewardHostname(),
  VERSION_ONE_API_PREFIX
)
export const JetpacCatalogApi = new Axios(
  generateJetpacCatalogHostname(),
  VERSION_ONE_API_PREFIX
)
export const OrbitPayApi = new Axios(
  generateOrbitPayHostname(),
  VERSION_ONE_API_PREFIX
)
export const OrbitApi = new Axios(
  generateOrbitHostname(),
  VERSION_ONE_API_PREFIX
)
export const JetpacB2BApi = new Axios(
  generateJetpacB2BHostname(),
  B2B_API_PREFIX
)

export const FaberApi = new Axios(generateJetpacSimHostname(), FABER_PREFIX)
export const JetpacOpsApi = new Axios(generateJetpacOpsHostname(), '/v1/ops')
// ops finance/refund endpoints, ported from the standalone jetpac-ops service
// (JetpacOpsApi above) into jetpac-sim's ops package
export const JetpacSimOpsApi = new Axios(
  generateJetpacSimHostname(),
  SIM_OPS_PREFIX
)
// read-only sim ops lookups (esims, allocations, plans)
export const JetpacSimOpsV2Api = new Axios(
  generateJetpacSimHostname(),
  SIM_OPS_V2_PREFIX
)
// mutating esim / pack assignment lifecycle actions
export const JetpacSimRevampOpsApi = new Axios(
  generateJetpacSimHostname(),
  SIM_REVAMP_OPS_PREFIX
)
